// Comma-separated env list → lowercased, trimmed, de-blanked email array.
const parsePrivilegeEmails = (raw: string | undefined): string[] =>
  (raw || "")
    .split(",")
    .map((email) => email.trim().toLowerCase())
    .filter(Boolean);

export const config = {
  NODE_ENV: process.env.NODE_ENV,
  APP_ENV: process.env.REACT_APP_ENV,

  API_URL: process.env.REACT_APP_API_URL,
  // API_URL: process.env.REACT_APP_LOCAL_API_URL, // local
  APP_URL: `${process.env.REACT_APP_URL}`,
  SOCKET_URL: `${process.env.REACT_APP_SOCKET_URL}`,
  LOCAL_API_URL: process.env.REACT_APP_LOCAL_API_URL,
  SENTRY_DSN: process.env.REACT_APP_SENTRY_DSN,

  ONE_SIGNAL_APP_ID: `${process.env.REACT_APP_ONE_SIGNAL_APP_ID}`,

  SENTRY_PUBLIC_KEY: process.env.REACT_APP_SENTRY_PUBLIC_KEY,
  SENTRY_RELEASE_KEY: process.env.REACT_APP_SENTRY_RELEASE_KEY,

  GOOGLE_MAPS_API_KEY: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  GOOGLE_MAPS_API_KEY_TIME_ZONE:
    process.env.REACT_APP_GOOGLE_MAPS_API_KEY_TIME_ZONE,

  PAGE_SIZE: Number(process.env.REACT_APP_PAGE_SIZE) || 0,
  MAX_KM_PER_HOUR: Number(process.env.REACT_APP_MAX_KM_PER_HOUR) || 0,
  ExhangeRate: {
    BASE_URL: process.env.REACT_APP_EXHANGE_RATE_BASE_URL,
    APP_ID: process.env.REACT_APP_EXHANGE_RATE_APP_ID,
  },
  GOOGLE_MAPS_API_URL: process.env.REACT_APP_GOOGLE_MAPS_API_URL,
  // Feature flags
  USE_NEW_PRICING_CALC:
    String(process.env.REACT_APP_USE_NEW_PRICING_CALC).toLowerCase() === "true",
  // Email-based privilege grants, grouped by category. Each list is
  // INDEPENDENT — an email in one category is NOT granted the others.
  // The backend (adminback) is the source of truth for enforcement; these
  // lists exist here only so the UI can gate fields/messages. Campaign-approver
  // is intentionally absent — the backend sends an `isApprover` flag per
  // campaign, so the client never needs that list. Keep in sync with adminback.
  PRIVILEGES: {
    // May create past-date bookings, edit bookings whose trip date is >24h old,
    // cancel directly, approve cancellation requests, and refund paid bookings.
    bookingModification: parsePrivilegeEmails(
      process.env.REACT_APP_PRIVILEGED_EMAILS
    ),
    // May export data for a range longer than 2 months (backend-enforced).
    export: parsePrivilegeEmails(process.env.REACT_APP_EXPORT_PRIVILEGED_EMAILS),
    // May refund/edit payment links (Refund + Edit buttons on the
    // payment-links page). Non-privileged users don't see the buttons.
    paymentLink: parsePrivilegeEmails(
      process.env.REACT_APP_PAYMENT_LINK_EMAILS
    ),
  },
};

export const EXTRA_CONFIG = {
  UNLIMITED_KM_ID:
    process.env.REACT_APP_UNLIMITED_KM_ID ||
    "695bc308aac88bb84905932b" ||
    "695bc308aac88bb84905932b",
  ADDITIONAL_DRIVER_ID:
    process.env.REACT_APP_ADDITIONAL_DRIVER_ID || "69410aff37be7ffba633c2e4",
    INTERNATIONAL_AUTH_ID: "695cb560c0c7a53fa8c14b36",
    FEUL_REFILL_ID: "695e14d29a9f1f698ad2a52d",

  // Optional: You could also store seat IDs if you want to handle them specially
  SEAT_EXTRAS: {
    CHILD_SEAT_ID: "690237a7121d6ac44b95badb",
    BABY_SEAT_ID: "694109f337be7ffba633c2d0",
    BOOSTER_SEAT_ID: "69410a6e37be7ffba633c2d7",
  },
};
